import StudentExamAPI from '@/apis/business/student/student-exam-api.js'
import SubmitExamAPI from '@/apis/business/student/submit-exam-api.js'
import { HttpStatusCode } from '@/common/constant'
import Enumeration from '@/common/enumeration.js'
import { handleSaveMappingAnswerOneQuestion, handleMappingAnswer } from '@/views/pages/teacher/storage/create/common/common.js'

export default {
  namespaced: true,
  state: {
    fileManager: [],
    examinationsList: [],
    examination: {},
    studentExamForReview: null,
    submittedExamination: {},
    questions: {},
    submitExam: null,
    uploadExamination: {},
    studentList: [],
    nodeSelected: 1,
    examThemeIndex: 3
  },
  getters: {},

  mutations: {
    /**
     * @description lưu thứ tự của node được chọn
     * @author lhlong
     * @param {*} state
     * @param {*} param
     */
    setSelectedNode (state, param) {
      state.nodeSelected = param
    },
    /**
     * @description set gía trị cho bài nộp học sinh khi kiểm tra
     * @author BNDung
     * @param {*} state
     * @param {*} param
     */
    setSubmitExam (state, param) {
      state.submitExam = { ...param }
    },
    /**
     * @description set giá trị cho
     * @param {*} state
     * @param {*} examination
     */
    setExamination (state, examination) {
      state.examination = examination
    },

    /**
     * @description set giá trị cho student exam phục vụ cho việc xem review
     * @author lhlong
     */
    setExaminationForReview (state, examination) {
      state.studentExamForReview = examination
    },

    setExaminationsList (state, examinationsList) {
      state.examinationsList = examinationsList
    },
    /**
     * @description clone object dùng để binding và submit
     * @param {*} state
     * @param {*} examination
     */
    setExaminationField (state, examination) {
      state.uploadExamination = examination
    },
    /**
     * Cập nhật câu trả lời
     * @param {*} state
     * @param {*} question
     */
    updateExamination (state, question) {
      const updateQuestion = state.uploadExamination.Questions.find((item) => {
        return item.SortOrder === question.SortOrder
      })
      const updateAnswer = updateQuestion.Answers.find((item) => {
        return item.SortOrder === question.SortOrderAnswer
      })
      switch (question.Type) {
        case Enumeration.QuestionType.Yesorno:
          updateAnswer.Correct = true
          updateQuestion.Done = false
          updateQuestion.Answers.forEach((item) => {
            if (item.SortOrder !== updateAnswer.SortOrder) {
              item.Correct = false
            }
            if (item.Correct) {
              updateQuestion.Done = true
            }
          })
          break
        case Enumeration.QuestionType.Select:
          updateAnswer.Correct = !updateAnswer.Correct
          updateQuestion.Done = false
          updateQuestion.Answers.forEach((item) => {
            if (item.Correct) {
              updateQuestion.Done = true
            }
          })
          break
        case Enumeration.QuestionType.Fill:
          updateAnswer.Content = question.Content
          updateAnswer.Correct = question.Content !== ''
          updateQuestion.Done = false
          updateQuestion.Answers.forEach((item) => {
            if (item.Correct) {
              updateQuestion.Done = true
            }
          })
          break
        case Enumeration.QuestionType.Essay:
          updateAnswer.AnswerAttachment = question.AnswerAttachment
          updateAnswer.Content = question.Content
          updateAnswer.Correct =
            question.Content !== '' || question.AnswerAttachment.length > 0
          updateQuestion.Done =
            question.Content !== '' || question.AnswerAttachment.length > 0
          break
        default:
          break
      }
    },

    /**
     * Cập nhật danh sách học sinh
     * @param {*} state
     * @param {*} studentLists
     * @author lhlong
     */
    setStudentList (state, studentList) {
      state.studentList = studentList
    }
  },
  actions: {
    /**
     * @description Lấy dữ liệu thông tin các bài kiểm tra
     * @author lhlong
     */
    async getExaminationsList (context, params) {
      const res = await StudentExamAPI.getAsync('/list', { params })
      if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
        context.commit('setExaminationsList', res.Data)
      }

      return res
    },

    /**
     * @description Lấy bài kiểm tra bằng id
     * @param {*} context
     * @param {*} param
     */
    getExaminationById (context, param) {
      return new Promise((resolve, reject) => {
        StudentExamAPI.getAsync(param)
          .then((res) => {
            context.commit('setExamination', res.Data)

            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy bài kiểm tra cho phòng chờ
     * @param {*} context
     * @param {*} param
     * BXHIEU 29/03/2022
     */
    updateExamAlert (context, params) {
      return new Promise((resolve, reject) => {
        StudentExamAPI.postAsync('exam-alert', params)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Cập nhật dữ liệu cảnh báo kỳ thi
     * @param {*} context
     * @param {*} param
     */
    getExamForWaitingRoom (context, params) {
      return new Promise((resolve, reject) => {
        StudentExamAPI.getAsync('waiting-room', { params })
          .then((res) => {
            if (res.IsSuccess) {
              if (res.Data.StudentExam) { context.commit('setExamination', res.Data.StudentExam) }
              if (res.Data.ListStudentExam) { context.commit('setStudentList', res.Data.ListStudentExam) }
            }

            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Cập nhật bài làm của học sinh
     * @author BNDung
     * @param {*} context
     * @param {*} classroom
     * @returns
     */
    updateQuestionTeacherExamById (context, params) {
      const bodyUpdate = {
        Id: params.TeacherExamPeriodID,
        Questions: params.Questions,
        UpdateFields: ['Questions']
      }
      return new Promise((resolve, reject) => {
        StudentExamAPI.putAsync(`/${params.TeacherExamPeriodID}`, bodyUpdate)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy bài kiểm tra để xem lại kết quả
     * @author lhlong
     */
    getExaminationToReview (context, params) {
      return new Promise((resolve, reject) => {
        StudentExamAPI.getAsync('/preview', { params })
          .then((res) => {
            context.commit('setExaminationForReview', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy dữ liệu bài kiểm tra tải lên
     * @param {*} context
     * @param {*} param
     * NVHUY1 13/10/2021
     */
    getUploadExamById (context, param) {
      return new Promise((resolve, reject) => {
        StudentExamAPI.getAsync(
          `do?id=${param.Id}&examPeriodID=${param.ExamPeriodID}&message=${param.Message}`
        )
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setExaminationField', res.Data)
              resolve(res)
            } else {
              resolve(res)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lưu bài kiểm tra
     * @param {*} context
     * @param {*} param
     * NVHUY1 13/08/2021
     * modified: lhlong - 18/04/2022
     */
    submitExamination (context, param) {
      return new Promise((resolve, reject) => {
        const exam = handleMappingAnswer(
          param,
          Enumeration.HandlePairingAnswerType.Convert
        )

        StudentExamAPI.postAsync('/submit', exam)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lưu nháp bài kiểm tra
     * @param {*} context
     * @param {*} param
     * lhlong 18/04/2022
     */
    saveDraftExamOneQuestion (context, payload) {
      return new Promise((resolve, reject) => {
        const question = handleSaveMappingAnswerOneQuestion(payload)
        SubmitExamAPI.postAsync('/submit-question', question)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
